import React, { useEffect, useState } from 'react';

import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import { isEmpty } from 'lodash';

import moment from 'moment';
import queryString from 'query-string';

import BobPage from '../../../components/BobPage';
import TableContainer from './TableContainer';
import BobTimeStampFilter from '../../../components/RuleExceptionsTable/BobTimestampFilter';
import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Navigation from '../Navigation/Navigation';
import HtmlTooltip from '../../../components/HtmlTooltip/HtmlTooltip';

import * as DashboardActions from '../../../actions/dashboardActions';

import classes from './ClientPage.module.css';

const ClientPage = ({
    activeNavClient,
    activeNavCompany,
    clearDashboardClientData,
    clientEquipmentMeta,
    clientSitesMeta,
    clientSystemsMeta,
    clientTabIndex,
    companyApplications,
    companyInfo,
    dashboardEndTimeStamp,
    dashboardStartTimeStamp,
    equipmentFilters,
    fetchClientEnergyData,
    fetchDashboardData,
    fetchDashboardEquipmentData,
    history,
    setClientTabIndex,
    siteFilters,
    systemFilters,
    targetNavClient,
    ...props
}) => {
    const [clientName, setClientName] = useState();
    const [activeTab, setActiveTab] = useState('');

    const queryValues = queryString.parse(history.location.search);

    useEffect(() => {
        return () => {
            setClientTabIndex(0);
            clearDashboardClientData();
        };
    }, []);

    useEffect(() => {
        const { pathname } = history.location;
        const k2aCoreAppId = '1710345b-cf28-4a02-9bf4-df9209ff29cb';
        const bobId = 'ad356bf2-b9db-4bb5-922e-c3394b1a63e3';

        if ( !queryValues.appId) queryValues.appId = bobId; // bob
        if ( queryValues.appId === k2aCoreAppId) queryValues.appId = k2aCoreAppId; // k2aCore

        // set id's if not exist for BOB menu
        if ( queryValues.appId === bobId ) {
            if ( !queryValues.parentId) queryValues.parentId = 'a73c8c70-35aa-48b7-a797-4c607ae25280';
            if ( !queryValues.childId) queryValues.childId = 'f6ba2344-ba47-42c5-a98b-978365ca3936';
        } else if ( queryValues.appId === k2aCoreAppId ) {
            if ( !queryValues.parentId) queryValues.parentId = '3ee59a8f-d13a-475b-b424-ee55eef98a65';
            if ( !queryValues.childId) queryValues.childId = 'e979b520-3695-422d-a914-ba55c51fb316';
        }

        if (!queryValues.company) queryValues.company = companyInfo.companyId;

        const queryValuesString = queryString.stringify(queryValues);

        history.push(`${pathname}?${queryValuesString}`);
    }, [companyInfo]);

    useEffect(() => {
        const init = async () => {
            await fetchClientEnergyData(activeNavCompany.id, activeNavClient.id, { sort: 'default^desc', page: 1, limit: 250 });
        };

        setClientName(activeNavClient.name);
        if (activeNavClient.id) {
            init();
        }
    }, [activeNavClient]);

    useEffect(() => {
        const init = async () => {
            let promises = [];

            if (!isEmpty(clientSitesMeta) && activeTab !== 'Site') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'ClientSite', { clientId: activeNavClient.id, sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            if (!isEmpty(clientEquipmentMeta) && activeTab !== 'Equipment') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'ClientEquipment', { clientId: activeNavClient.id, sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            if (!isEmpty(clientSystemsMeta) && activeTab !== 'System') {
                promises.push(fetchDashboardData(activeNavCompany.id, 'ClientSystem', { clientId: activeNavClient.id, sort: 'default^desc', startDate: dashboardStartTimeStamp.format(), endDate: dashboardEndTimeStamp.format() }));
            }

            await Promise.all(promises.map(p => p.catch(err => err)));
        };

        if (activeNavCompany.id && activeNavClient.id) init();
    }, [activeNavClient.id, dashboardEndTimeStamp, dashboardStartTimeStamp]);

    const buildEntityNameTooltip = props => {
        const primaryContactName = props.primaryContact && props.primaryContact.name ? props.primaryContact.name : '';
        return (
            <div>
                <div className="entityTooltipTitle">Client Information</div>
                <div className="entityTooltipHeader">Address</div>
                <div className="entityTooltipDetail">{props.address.formattedAddress}</div>
                <div className="entityTooltipHeader">Business Type</div>
                <div className="entityTooltipDetail">{props.businessType.name}</div>
                {props.primaryContact ?
                    <div><div className="entityTooltipHeader">Primary Contact</div><div className="entityTooltipDetail">{primaryContactName}</div></div>
                    : null
                }
            </div>
        );
    };

    return (
        <BobPage>
            <div className={classes.ClientPage}>
                <div className={classes.BreadcrumbPanel}>
                    <Breadcrumb />
                </div>
                <div className={classes.HeaderPanel}>
                    <div className={classes.NavigationPanel}>
                        <Navigation />
                    </div>
                    <div className={classes.Date}>
                        {
                            activeTab === 'Contact' || activeTab === 'Health Monitor' ?
                                null
                                :
                                <BobTimeStampFilter
                                    className={classes.TimestampOverride}
                                    maxDate={moment().local()}
                                    disableIntervalSelector={true}
                                />
                        }
                    </div>
                </div>
                <div className={classes.DataPanel} />
                <div className={classes.TitlePanel}>
                    <div className={classes.Name}>
                        {clientName}
                        {activeNavClient.address ?
                            <HtmlTooltip
                                information={buildEntityNameTooltip(activeNavClient)}
                                placement={'right-start'}
                                body={
                                    <div className={'infoIcon'}><span className="material-icons-outlined md-16" style={{ cursor: 'default' }}>info</span></div>
                                }
                            />
                            : null
                        }
                    </div>
                </div>
                <div className={classes.TablePanel}>
                    <TableContainer
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                    />
                </div>
            </div>
        </BobPage>
    );
};

const mapStateToProps = state => {
    return {
        activeNavClient:         state.bob.activeNavClient,
        activeNavCompany:        state.bob.activeNavCompany,
        clientEquipmentMeta:     state.dashboard.clientEquipmentMeta,
        clientFilters:           state.dashboard.clientFilters,
        clientSitesMeta:         state.dashboard.clientSitesMeta,
        clientSystemsMeta:       state.dashboard.clientSystemsMeta,
        clientTabIndex:          state.dashboard.clientTabIndex,
        companyApplications:     state.bob.companyApplications,
        companyInfo:             state.companyInfo,
        dashboardEndTimeStamp:   state.dashboard.dashboardEndTimeStamp,
        dashboardStartTimeStamp: state.dashboard.dashboardStartTimeStamp,
        equipmentFilters:        state.dashboard.equipmentFilters,
        siteFilters:             state.dashboard.siteFilters,
        systemFilters:           state.dashboard.systemFilters,
        targetNavClient:         state.bob.targetNavClient
    };
};

const mapDispatchToProps = {
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientPage));
